// Полный редирект браузера на внешний URL (например, страницу оплаты банка).
// Вынесено отдельной функцией, чтобы тесты могли её замокать вместо реальной
// навигации happy-dom.
export function redirectTo(url: string): void {
  window.location.href = url;
}

/**
 * ANX-117 — увести оператора на экран входа при невосстановимой потере сессии
 * (refresh провалился / access истёк без валидного refresh). Полный редирект
 * (а не router.navigate), потому что onAuthFail зовётся вне реактивного
 * контекста роутера — guard сам по себе не сработает. `?expired=1` → LoginForm
 * покажет «сессия истекла». Гард от зацикливания, если уже на /login.
 */
export function redirectToLogin(): void {
  if (window.location.pathname.startsWith('/login')) return;
  window.location.assign('/login?expired=1');
}
